import React from 'react'
import { Autocomplete } from '@atd/rui-base.mui.autocomplete'
import { Button } from '@atd/rui-base.mui.button'
import { TextField } from '@atd/rui-base.mui.text-field'
import ResponsiveDialog from '../commonComponents/responsiveDialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import DialogHeader from '../commonComponents/dialogHeader'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {format} from 'date-fns'


import * as rxMapActions from './rxMapActions'
import { selectMixes } from './productReducer'

import './productConfigStyles.css'

function mapStateToProps(state, ownProps) {
    return {
        mixes: selectMixes(state),
        rxFiles: state.product.rxFiles,
        currentProducts: state.product.currentProducts,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(rxMapActions, dispatch),
    }
}

class RxMapSearch extends React.Component {
    static defaultProps = {
        open: true,
        initRxMapId: null,
        onNewRxRequest: () => {},
        onCancel: () => {},
        onRxSelect: (rxMap) => {},
    }

    state = {
        searchString: '',
        rxMap: null,
        open: true,
    }

    componentDidMount() {
        if (this.props.initRxMapId) {
            const rxMap = this.props.rxFiles.find(file => file.id === this.props.initRxMapId)
            if (rxMap) {
                this.checkFileMeta(rxMap)
                this.setState({
                    rxMap,
                    searchString: rxMap.clientFileName,
                })
            }
        }
    }

    // eslint-disable-next-line complexity
    static getDerivedStateFromProps(props, state) {
        // no map is currently selected, so we have nothing to update
        if (!state.rxMap || !state.rxMap.id) return null

        // check if meta information about the map has been updated
        const nextMap = props.rxFiles.find(file => file.id === state.rxMap.id)
        if (!nextMap) return
        if ((!state.rxMap.columns && nextMap.columns) ||
            (state.rxMap.columns?.length != nextMap.columns?.length) ||
            (!state.rxMap.boundingBox && nextMap.boundingBox) ||
            (state.rxMap.boundingBox?.length != nextMap.boundingBox?.length) ||
            (!state.rxMap.shapes && nextMap.shapes) ||
            (!state.rxMap.shapes.features && nextMap.shapes.features) ||
            (state.rxMap.shapes.features?.length != nextMap.shapes.features?.length)
        ) {
            return {
                ...state,
                rxMap: nextMap,
            }
        }

        return null
    }

    checkFileMeta = (rxMap) => {
        if (rxMap.id &&
            (!rxMap.columns.length ||
             !rxMap.shapes ||
             !rxMap.shapes.features ||
             !rxMap.shapes.features.length ||
             !rxMap.boundingBox.length
            )
        ) {
            this.props.fetchRxMapMeta(rxMap.id)
        }
    }

    requestClose = (onComplete) => {
        this.exitCallback = onComplete
        this.setState({open: false})
    }
    renderDialogActions = () => {
        return [
            <Button variant="text"
                key="cancel"
                onClick={() => this.requestClose(this.props.onCancel)}
                color="primary">Cancel</Button>,
            <Button variant="text"
                key="upload"
                onClick={() => this.requestClose(this.props.onNewRxRequest)}
                name="addRxButton"
                color="primary">Upload</Button>,
            <Button variant="contained"
                key="select"
                onClick={() => this.requestClose(() => this.props.onRxSelect(this.state.rxMap))}
                disabled={!this.state.rxMap}
                color="primary">Select</Button>,
        ]
    }
    handleNewSelection = (chosenRequest, index) => {
        if (index >= 0) {
            const rxMap = this.props.rxFiles[index]
            this.checkFileMeta(rxMap)
            this.setState({
                rxMap,
                searchString: rxMap.clientFileName,
            })
        }
        else {
            this.setState({
                rxMap: null,
                searchString: chosenRequest,
            })
        }
    }
    handleUpdateInput = (searchString) => {
        const rxMap = this.props.rxFiles.find(file => file.clientFileName === searchString)
        if (rxMap) { this.checkFileMeta(rxMap) }
        this.setState({
            searchString,
            rxMap,
        })
    }
    renderMapInformation = () => {
        if (!this.state.rxMap) return

        const infoStrings = []
        if (this.state.rxMap.lastModified) {
            // new job, go to products, select rx map, scroll to top, click search, pick a map
            infoStrings.push(`Received: ${format(new Date(this.state.rxMap.lastModified), 'P p')}`)
        }
        if (this.state.rxMap.columns) {
            infoStrings.push(`Columns: ${this.state.rxMap.columns.join(', ')}`)
        }
        if (this.state.rxMap.shapes && this.state.rxMap.shapes.features) {
            infoStrings.push(`Shapes: ${this.state.rxMap.shapes.features.length}`)
        }

        return infoStrings.map((data, i) => {
            return <div key={i}>{data}</div>
        })
    }
    render() {
        return (
            <ResponsiveDialog
                open={this.state.open}
                onClose={(_, reason) => { if (reason !== 'backdropClick') this.requestClose(this.props.onCancel) }}
                TransitionProps={{onExited: () => { if (this.exitCallback) this.exitCallback() }}}
                PaperProps={{className: 'wodialog'}}
                fullWidth
            >
                <DialogHeader onClose={() => this.requestClose(this.props.onCancel)}>Rx Map Search</DialogHeader>
                <DialogContent sx={{minHeight: 165}}>
                    <Autocomplete
                        fullWidth
                        openOnFocus
                        options={this.props.rxFiles}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : (option.clientFileName || ''))}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        slotProps={{ popper: { style: { zIndex: 2200 } } }}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>{option.clientFileName}</li>
                        )}
                        inputValue={this.state.searchString}
                        onInputChange={(_, value) => this.handleUpdateInput(value)}
                        onChange={(_, value) => this.handleNewSelection(value)}
                        className="rxFileSelect"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Rx Map Name"
                                error={!this.state.rxMap}
                                helperText={!this.state.rxMap && 'Invalid Map'}
                                name="rxMapSelect"
                            />
                        )}
                    />
                    <div>{this.renderMapInformation()}</div>
                </DialogContent>
                <DialogActions>{this.renderDialogActions()}</DialogActions>
            </ResponsiveDialog>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RxMapSearch)
